module.exports = __webpack_public_path__ + "img/sniper_fbs_samurai_01.f74109a8.png";